import { ShippingZoneApi } from '../models/Shipping';

/** Nombre del tipo de zona que enruta un pedido a la etiqueta del Correo. */
const LABEL_ZONE_TYPE_NAME = 'labelZone';

interface CorreoLabelSubject {
  labelNumber?: string | null;
  shippingZones?: ShippingZoneApi[];
}

/**
 * Un pedido queda enrutado al Correo cuando cae dentro de una zona de tipo
 * `labelZone` (lo que en la operativa se llama "interior").
 */
export function isCorreoRouted(shipping: CorreoLabelSubject): boolean {
  return (
    shipping.shippingZones?.some(
      zone => zone.zoneType?.name === LABEL_ZONE_TYPE_NAME
    ) ?? false
  );
}

/**
 * Interior sin tracking del Correo: el pedido debería llevar etiqueta del
 * Correo pero nunca se le generó el número. Se muestra distinto de un "N/A"
 * para poder detectarlos y corregirlos.
 */
export function isMissingCorreoLabelNumber(
  shipping: CorreoLabelSubject
): boolean {
  return !shipping.labelNumber?.trim() && isCorreoRouted(shipping);
}
